import React from 'react';
import { Box } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DOCUMENT } from '../constants/documentTheme';

const linkSx = (active) => ({
  fontFamily: DOCUMENT.sans,
  fontSize: 12,
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  textDecoration: 'none',
  color: active ? DOCUMENT.oxblood : DOCUMENT.ink2,
  borderBottom: active ? `1px solid ${DOCUMENT.oxblood}` : '1px solid transparent',
  pb: 0.4,
  '&:hover': { color: DOCUMENT.ink },
});

/** Section links under Packages: the catalog and the DMC contact book. */
const PartnerPackagesSubnav = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const onDmcs = pathname.startsWith('/partner/packages/dmcs');

  return (
    <Box data-testid="partner-packages-submenu" sx={{ display: 'flex', gap: 3, pt: 2.25 }}>
      <Box
        component={RouterLink}
        to="/partner/packages"
        data-testid="partner-packages-submenu-packages"
        sx={linkSx(!onDmcs)}
      >
        {t('partnerNav.packages')}
      </Box>
      <Box
        component={RouterLink}
        to="/partner/packages/dmcs"
        data-testid="partner-packages-submenu-dmcs"
        sx={linkSx(onDmcs)}
      >
        {t('partnerNav.dmcs')}
      </Box>
    </Box>
  );
};

export default PartnerPackagesSubnav;
